import {
    SIGNOUT, SIGNOUT_SAGA, SIGNIN, SIGNINSUCCESS, SIGNINFAILURE, SIGNUP, SIGNUPSUCCESS, SIGNUPFAILURE, AUTH_CHALLENGE, CLEAR_AUTH_CHALLENGE
  } from '../types';
  
  const signIn = (credentials) => ({
    type: SIGNIN,
    credentials
  });
  
  const signInSuccess = (payload) => ({
    type: SIGNINSUCCESS,
    ...payload
  });
  
  const signInFailure = () => ({
    type: SIGNINFAILURE
  });
  
  const signOut = () => {
    return {
      type: SIGNOUT,
    };
  };

  const signOutSaga = () => {
    return {
      type: SIGNOUT_SAGA,
    };
  };

  const signUp = (credentials) => ({
    type: SIGNUP,
    credentials
  });

  const signUpSuccess = (payload) => ({
    type: SIGNUPSUCCESS,
    ...payload
  });
  
  const signUpFailure = () => ({
    type: SIGNUPFAILURE
  });

  const authChallenge = (challengeName, user) => ({
    type: AUTH_CHALLENGE,
    challengeName,
    user
  });

  const clearAuthChallenge = () => ({
    type: CLEAR_AUTH_CHALLENGE
  });
  
  export {
    signOut,
    signOutSaga,
    signIn,
    signInSuccess,
    signInFailure,
    signUp,
    signUpSuccess,
    signUpFailure,
    authChallenge,
    clearAuthChallenge
  };
  